<route>
{
  "meta": {
    "permission": [
      "invoices.view_receivable"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <i-table
      api="invoice.receivable"
      app="invoices.receivable"
      dontCreate
      dontRemove
      :headers="headers"
      :opt="{
        company_id: this.company.pk,
        status: 'outstanding'
      }"
      :otherPermission="checkPermissions.payment"
      :title="$tc('receivable', 2)"
      @click:edit="changeRoute"
    >
      <template v-slot:item.customer="{ value }">
        {{
          value.company_name
            ? value.company_name
            : `${value.first_name} ${value.last_name}`
        }}
      </template>
      <template v-slot:item.state="{ value }">
        {{ value === 'paid' ? $tc(value, 0) : $t(value) }}
      </template>
      <template v-slot:item.date_init="{ value }">
        {{ dateFormat(value) }}
      </template>
      <template v-slot:item.date_end="{ value }">
        {{ dateFormat(value) }}
      </template>
      <template v-slot:item.balance="{ value }">
        <i-money :value="value" mode="text" />
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      total: 0,
      loading: false,
      receivable: []
    }
  },
  methods: {
    changeRoute(item) {
      this.$router.push({
        name: 'receivable-pk',
        params: { pk: this.codification({ code: item.pk }) }
      })
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('number_control'),
          value: 'code'
        },
        {
          text: this.$tc('order', 1),
          value: 'order_name'
        },
        {
          text: this.$tc('start_date'),
          value: 'date_init'
        },
        {
          text: this.checkPermissions.customer ? this.$tc('customer', 1) : '',
          value: this.checkPermissions.customer ? 'customer' : ''
        },
        {
          text: this.$t('balance'),
          value: 'balance',
          align: 'right'
        },
        {
          text: this.$t('status'),
          value: 'state'
        },
        {
          text: this.checkPermissions.edit ? this.$t('action') : '',
          value: this.checkPermissions.edit ? 'actions' : '',
          align: 'center',
          width: '160px'
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin',
      company: 'company/getCompanyData'
    }),
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        customer: this.getPermissions([`customer.view_customer`]),
        edit: this.getPermissions([`invoices.change_receivable`]),
        payment: this.getPermissions([`invoices.view_payment`])
      }
    }
  }
}
</script>
